import React from 'react';

import { IMetalGroup } from '../../../../sharedInterfaces';

import {
  MaterialSectionContainer,
  MaterialSectionHeaderBottomText,
  MaterialSectionHeaderContainer,
  MaterialSectionHeaderLeftSide,
  MaterialSectionHeaderRightSide,
  MaterialSectionHeaderTopText,
  MaterialsTabContainer,
  PuritySectionContainer
} from './MaterialsLUXE-styled';
import { isLowHeight, isMobile } from '../../../shared/UIHelpers/Functions/Functions';
import { TabHeader } from '../Tabs-styled';
import { GridMenuItem } from '../../UIHelpersLUXE/GridMenu/GridMenuItem';
import { PuritySelector } from './PuritySelector';
import { GridMenuOptionsContainer } from '../../UIHelpersLUXE/GridMenu/GridMenu-styled';
import { SliderMenu, SliderMenuOption } from '../../UIHelpersLUXE/SliderMenu/SliderMenu';


interface Props {
  metalGroup:IMetalGroup,
  onParameterChange:(param:'material'|'surface'|'purity',value:any)=>void,
  limitedMaterials:string[],
  assetURI:string,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

interface State {
}


export default class MaterialsMobile extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  }

  render = () => {
    const {
      metalGroup,
      onParameterChange,
      limitedMaterials,
      assetURI,
      mobile,
      menuHeight,
      menuScaleFactor
    } = this.props;

    const {
      name,
      material,
      materialOptions,
      surface,
      surfaceOptions,
      purity,
      purityOptions
    } = metalGroup;

    const sliderMenuMaterialOptions:SliderMenuOption[] = materialOptions.map((option) => {
      return {
        label: option,
        value: option,
        imageURI: `${assetURI}/images/materials/${option} ${surface}.png`
      }
    })

    const sliderMenuSurfaceOptions:SliderMenuOption[] = surfaceOptions.map((option) => {
      return {
        label: option,
        value: option,
        imageURI: `${assetURI}/images/materials/${material} ${option}.png`
      }
    })

    return (
      <MaterialsTabContainer mobile={mobile} menuHeight={menuHeight} menuScaleFactor={menuScaleFactor}>
        <TabHeader>CHOOSE {metalGroup.name} METAL</TabHeader>

        {(materialOptions.length > 0) &&
          <React.Fragment>
            <PuritySectionContainer>
              {purityOptions && purityOptions.length > 0 &&
                <PuritySelector
                  selectedPurity={purity}
                  purityOptions={purityOptions}
                  changePurity={(purity) => onParameterChange('purity', purity)}
                />
              }
            </PuritySectionContainer>
            <MaterialSectionContainer>
              <MaterialSectionHeaderContainer>
                <MaterialSectionHeaderLeftSide>Metal</MaterialSectionHeaderLeftSide>
              </MaterialSectionHeaderContainer>
              <SliderMenu
                options={sliderMenuMaterialOptions}
                selectedValue={material}
                onChange={(value) => onParameterChange('material', value)}
                optionTileWidth={100*menuScaleFactor}
                optionTileHeight={85*menuScaleFactor}
                imageSize={48*menuScaleFactor}
              />
            </MaterialSectionContainer>
          </React.Fragment>
        }

        {(surfaceOptions.length > 0) && !limitedMaterials.includes(material) && 
          <MaterialSectionContainer>
            <MaterialSectionHeaderContainer>
              <MaterialSectionHeaderLeftSide>Finishing</MaterialSectionHeaderLeftSide>
            </MaterialSectionHeaderContainer>

            <SliderMenu
              options={sliderMenuSurfaceOptions}
              selectedValue={surface}
              onChange={(value) => onParameterChange('surface', value)}
              optionTileWidth={100*menuScaleFactor}
              optionTileHeight={85*menuScaleFactor}
              imageSize={48*menuScaleFactor}
            />
          </MaterialSectionContainer>
        }
      </MaterialsTabContainer>
    )
  }
}